
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/summarization/bullet-points-extraction",
      function () {
        return require("private-next-pages/summarization/bullet-points-extraction.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/summarization/bullet-points-extraction"])
      });
    }
  